export default "__VITE_ASSET__BkR1nTVr__"